








































import { Vue, Component, Prop } from 'vue-property-decorator'

export interface DropdownOption {
    name: string
    value: string
    icon: string
    class?: string
    href?: string
    action?: string
}

@Component({ name: 'v-dropdown' })
export default class VDropdown extends Vue {
    /**
     * Options to show in the dropdown
     */
    @Prop({ type: [Array, Object], default: () => [] })
    options!: DropdownOption[]

    /**
     * Side to anchor the dropdown to
     */
    @Prop({ type: String, default: 'right' })
    anchor!: 'left' | 'right' | 'middle'

    /**
     * Whether to drop upwards rather than down
     */
    @Prop({ type: Boolean, default: false })
    dropUp!: boolean

    /**
     * Whether to drop upwards rather than down
     */
    @Prop({ type: Boolean, default: false })
    fullWidth!: boolean

    @Prop({ type: Boolean, default: false })
    ignoreButton!: boolean

    /**
     * Whether the dropdown is open
     */
    open: boolean = false

    /**
     * Toggle the dropdown open, and add an event listener to close it
     */
    toggle(): void {
        this.open = !this.open
        this.$nextTick(() => {
            if (this.open) {
                window.addEventListener('click', this.toggle)
            } else {
                window.removeEventListener('click', this.toggle)
            }
        })
    }

    /**
     * Emit value to parent and close the dropdown
     */
    update(value: string, action?: () => void): void {
        this.open = false
        window.removeEventListener('click', this.toggle)
        this.$nextTick(() => {
            this.$emit('input', value)
            if (action) {
                action()
            }
        })
    }
}
